import React, { useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setAuthed } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    const run = async () => {
      if (!sid) { navigate("/login"); return; }
      try {
        const { data } = await axios.get(`${API}/auth/google/session`, { params: { session_id: sid } });
        window.history.replaceState(null, "", "/");
        setAuthed(data);
        navigate("/");
      } catch {
        navigate("/login");
      }
    };
    run();
  }, [navigate, setAuthed]);

  return (
    <div className="dark flex min-h-screen items-center justify-center bg-[#03050A] text-cyan-400">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin" />
        <p className="font-mono text-xs uppercase tracking-widest">Signing you in…</p>
      </div>
    </div>
  );
}
